import React from 'react';
import Axios from 'axios';
var moment = require('moment');

const PAGER_DISPPAGES = 5;
const PAGER_PAGESIZE = 20;

class ConnectionsTable extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			connections: [],
			pager: {
				startIndex: 0,
				endIndex: 10,
				totalItems: 0
			},
			loading: true
		};
	
		this.createTableRow = this.createTableRow.bind(this);
	}

	componentDidMount() {
		// console.log('ConnectionsTable: componentDidMount');
		this.initiatePagerSizeWithData();
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('ConnectionsTable: UNSAFE_componentWillReceiveProps');
		this.initiatePagerSizeWithData();
	}

	initiatePagerSizeWithData() {
		var _this = this;
		Axios.get('/api/connections/size/').then(function(response) {
			var pager = _this.state.pager;
			pager.totalItems = response.data.count;
			_this.setPage(1, pager);
		});
	}

	setPage(page, pager) {
		// set optional parameters
		var pager = pager || this.state.pager;
		if (page < 1 || page > pager.totalPages) { return; }
 
		// get new pager object for specified page
		pager = this.getPager(pager.totalItems, page);
		this.loadData(pager);
	}

	getPager(totalItems, currentPage, pageSize) {
		// default to first page
		currentPage = currentPage || 1;
 
		// default page size is 10
		pageSize = pageSize || PAGER_PAGESIZE;
 
		// calculate total pages
		var totalPages = Math.ceil(totalItems / pageSize);
 
		var startPage, endPage;
		if (totalPages <= PAGER_DISPPAGES) {
			// less than 10 total pages so show all
			startPage = 1;
			endPage = totalPages;
		} else {
			// more than 10 total pages so calculate start and end pages
			if (currentPage <= (PAGER_DISPPAGES/2+1)) {
				startPage = 1;
				endPage = PAGER_DISPPAGES;
			} else if (currentPage + (PAGER_DISPPAGES/2-1) >= totalPages) {
				startPage = totalPages - (PAGER_DISPPAGES-1);
				endPage = totalPages;
			} else {
				startPage = currentPage - Math.ceil(PAGER_DISPPAGES / 2);
				endPage = currentPage + Math.ceil((PAGER_DISPPAGES / 2) - 1);
			}
		}
 
		// calculate start and end item indexes
		var startIndex = (currentPage - 1) * pageSize;
		var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);
 
		// create an array of pages to ng-repeat in the pager control
		// var pages = _.range(startPage, endPage + 1);     // lodash function
		var pages = Array.apply(0, Array(endPage - startPage + 1)).map(function (element, index) { 
			return index + startPage;  
		});
	
		// return object with all pager properties required by the view
		return {
			totalItems: totalItems,
			currentPage: currentPage,
			pageSize: pageSize,
			totalPages: totalPages,
			startPage: startPage,
			endPage: endPage,
			startIndex: startIndex,
			endIndex: endIndex,
			pages: pages
		};
	}

	loadData(pager) {
		//console.log('loadData:');
		var _this = this;
		Axios.get('/api/connections/start/' + pager.startIndex + '/end/' + (pager.endIndex + 1)).then(function(response) {
			_this.setState({
				pager: pager,
				connections: response.data,
				loading: false
			});
		});
	}

	render() {
		//console.log('ConnectionsTable: render');
		//console.log(this.state.pager);
		var pager = this.state.pager;
		if (!pager.pages || pager.pages.length < 1) {
			return null;
		}
		
		return (
			<div>
				{this.displayModule(pager)}
				{this.displayPagination(pager)}
			</div>
		);
	}

	displayModule(pager) {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData(pager) );
		}
	}

	displaySpinner() {
		return (
			<div className="sk-three-bounce">
				<div className="sk-child sk-bounce1"></div>
				<div className="sk-child sk-bounce2"></div>
				<div className="sk-child sk-bounce3"></div>
			</div>
		);
	}

	displayData(pager) {
		return (
			<div>
			<p>{pager.totalItems} connections</p>
			<div className="table-responsive">
			<table className="table table-striped table-hover table-responsive table-sm">
			<thead>
				<tr>
				<th> ID </th>
				<th> userId </th>
				<th> auth0_user_id </th>
				<th> auth0_name </th>
				<th> lastConnectionDate </th>
				</tr>
			</thead>

			<tbody>
				{this.state.connections.map(this.createTableRow)}
			</tbody>
			</table>
			</div>
			</div>
		);
	}

	displayPagination(pager) {
		return (
			<ul className="pagination">
				<li className={pager.currentPage === 1 ? 'disabled' : ''}>
					<a onClick={() => this.setPage(1)}>{"<<"}</a>
				</li>
				<li className={pager.currentPage === 1 ? 'disabled' : ''}>
					<a onClick={() => this.setPage(pager.currentPage - 1)}>{"<"}</a>
				</li>
				{pager.pages.map((page, index) =>
					<li key={index} className={pager.currentPage === page ? 'active' : ''}>
						<a onClick={() => this.setPage(page)}>{page}</a>
					</li>
				)}
				<li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
					<a onClick={() => this.setPage(pager.currentPage + 1)}>{">"}</a>
				</li>
				<li className={pager.currentPage === pager.totalPages ? 'disabled' : ''}>
					<a onClick={() => this.setPage(pager.totalPages)}>{">>"}</a>
				</li>
			</ul>
		);
	}

	createTableRow(item, idx) {
		return (
			<tr key={item._id}>
				<td>{item._id}</td>
				<td>{item.userId}</td>
				<td>{item.auth0_user_id}</td>
				<td>{item.auth0_name}</td>
				<td>{moment(item.lastConnectionDate).local().format("YYYY-MM-DD HH:mm:ss")}</td>
		   </tr>
		);
	}

}

export default ConnectionsTable;
